"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SlideContent = void 0;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@dbi-tools/ui-kit");

var _const = require("../../../../const");

var _helpers = require("../../../../helpers");

var _slideContent = require("./slide-content.styled");

var _lazyLoadImage = require("../../../lazy-load-image");

var _const2 = require("./const");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SlideContent = function SlideContent(_ref) {
  var line1 = _ref.line1,
      line2 = _ref.line2,
      line3 = _ref.line3,
      buttons = _ref.buttons,
      bg = _ref.bg,
      logoLayout = _ref.logoLayout,
      logoFileReference = _ref.logoFileReference,
      logoAltText = _ref.logoAltText;
  var colorContrast = bg ? _const.ButtonContrast[bg] : 'gray800';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, logoFileReference && /*#__PURE__*/_react.default.createElement(_slideContent.LogoContainerStyled, null, /*#__PURE__*/_react.default.createElement(_slideContent.LogoWrapStyled, {
    isHorizontal: logoLayout === 'horizontal'
  }, /*#__PURE__*/_react.default.createElement(_lazyLoadImage.LazyLoadImage, {
    src: logoFileReference,
    placeholderSrc: logoFileReference,
    alt: logoAltText
  }))), line1 && /*#__PURE__*/_react.default.createElement(_slideContent.Line1Styled, {
    as: "h2"
  }, line1), line2 && /*#__PURE__*/_react.default.createElement(_slideContent.Line2Styled, {
    as: "h3"
  }, line2), line3 && /*#__PURE__*/_react.default.createElement(_slideContent.Line3Styled, {
    as: "p"
  }, line3), buttons && !!buttons.length && buttons.map(function (_ref2, index) {
    var link = _ref2.link,
        text = _ref2.text,
        type = _ref2.type,
        buttonColor = _ref2.buttonColor;
    var _heroSlideButtonsProp = _const2.heroSlideButtonsProps[buttonColor || _const2.HeroSlideButtonColor.WHITE_GHOST],
        variant = _heroSlideButtonsProp.variant,
        color = _heroSlideButtonsProp.color;
    return /*#__PURE__*/_react.default.createElement(_slideContent.ButtonWrapp, {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
      as: "a",
      variant: buttonColor ? variant : (0, _helpers.getButtonStyleByType)(type),
      color: buttonColor ? color : colorContrast,
      href: link,
      fullWidth: type !== 'link'
    }, text));
  }));
};

exports.SlideContent = SlideContent;